import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import { BForm, BSubmit, BTextField } from 'mui-bueno';
import { CreateTaskResponse, LoadingProps, Task } from '../../@types';
import { useCardStyles, useFormStyles } from '../../App';
import theme from '../../theme';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { createTask, createTaskResponse } from '../../axios/tasks';
import Box from '@material-ui/core/Box';
import { string } from 'yup';
import Grid from '@material-ui/core/Grid';
import IsLoadingHOC from '../../IsLoadingHOC';

const useStyles = makeStyles({
	root: {
		margin: '0 auto',
		padding: '30px',
		backgroundColor: theme.palette.secondary.dark,
		borderRadius: '10px',
	},
	inputField: {
		width: '100%',
		marginBottom: '10px',
	},
	loginButton: {
		textAlign: 'center',
		margin: '15px auto 20px',
		backgroundColor: theme.palette.secondary.main,
	},
	resetButton: {
		textAlign: 'center',
		margin: '15px auto 20px',
		backgroundColor: theme.palette.secondary.dark,
	},
	question: {
		color: theme.palette.common.black,
		paddingLeft: theme.spacing(1),
	},
});

export type CreateTaskResponseProps = {
	task: Task;
	onClose: any
};

export  const CreateResponse = (props: CreateTaskResponseProps & LoadingProps) => {
	// const globalClasses = useOtherStyles();
	const formClasses = useFormStyles();
	const history = useHistory();
	const dispatcher = useDispatch();
	const classes = useStyles();
	const cardStyles = useCardStyles();

	const initialValues: CreateTaskResponse = {
		task_id: '',
		data: {
			ans1: '',
			ans2: '',
			ans3: '',
		},
	};

	const handleSubmit = (data: CreateTaskResponse) => {
		let submission = {
			// task_id: props.task.qId,
			task_id: props.task.id,
			data: data.data
		}
		props.setLoading(true)
		createTaskResponse(submission)
			.then((res) => {
				props.setLoading(false)
				props.onClose()
			})
			.catch((err: any) => {
				alert(err);
				props.setLoading(false)
				console.log('ERROR: ', err);
			});
	};

	const textFieldProps = {
		type: 'number',
		InputProps: {
			inputProps: {
				max: 100,
				min: 1,
			},
		},
	};

	return (
		<Box className={formClasses.formWrapper}>
			{/* <Card className={cardStyles.card}> */}
			<Formik
				initialValues={initialValues}
				onSubmit={handleSubmit}
				validateOnChange={false}
				validateOnBlur={false}
			>
				<BForm>
					<Typography className={classes.question}>
						Question 1: {props.task.data.q1}
					</Typography>
					<BTextField
						required
						name='data.ans1'
						label='Answer 1'
						full
						className={classes.inputField}
					/>
					{props.task.data.q2 ? (
						<>
							<Typography className={classes.question}>
								Q2: {props.task.data.q2}
							</Typography>
							<BTextField
								// required
								name='data.ans2'
								label='Answer 2'
								full
								className={classes.inputField}
							/>
						</>
					) : (
						''
					)}
					{props.task.data.q3 ? (
						<>
							<Typography className={classes.question}>
								{props.task.data.q3}
							</Typography>
							<BTextField
								// required
								name='data.ans3'
								label='Answer 3'
								full
								className={classes.inputField}
							/>
						</>
					) : (
						''
					)}

					<BSubmit className={classes.loginButton} name='submit'>
						Respond To Task
					</BSubmit>
				</BForm>
			</Formik>
			{/* </Card> */}
		</Box>
	);
};

export default IsLoadingHOC(CreateResponse);
